<template>
  <div>
    <b-modal
      v-model="modalShow"
      centered
      no-close-on-backdrop
      hide-header
      hide-footer
      ok-disabled
      cancel-disabled
    >
      <div class="d-block text-center modal-container">
        <div v-if="isForced" class="content-subject">{{ $t('order.endOrder') }}</div>
        <div v-else class="content-subject">{{ $t('order.endOrderConfirmation') }}</div>
        <div v-if="isForced" class="content-desc">
          {{ $t('order.endSession') }}
        </div>
        <div v-else class="content-desc">
          <div v-if="isParent" class="content-warning">
            {{ $t('order.endOrderAttention') }}
          </div>
          <div v-else class="content-warning">{{ $t('order.askEndOrder') }}</div>
        </div>
        <div>
          <b-row class="buttons">
            <b-col v-if="!isForced">
              <div class="buttons-button-cancel" @click="handleCancel">
                {{ $t('common.cancel') }}
              </div>
            </b-col>
            <b-col>
              <div block class="buttons-button-quit" @click="handleQuit">
                {{ $t('common.end') }}
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'OrderQuittingModal',
  computed: {
    ...mapGetters({
      isChildTerminal: 'seat/getIsChildTerminal',
      isForced: 'setting/getIsForceQuit',
      modalShow: 'modal/isShowingOrderQuittingModal',
    }),
    isParent() {
      return this.isChildTerminal === 0
    },
    isApp() {
      return process.env.VUE_APP_TYPE === 'app'
    },
  },
  methods: {
    ...mapActions({
      deauth: 'auth/deauth',
      showModal: 'modal/setShowingOrderQuittingModal',
    }),
    handleCancel() {
      this.showModal(false)
    },
    async handleQuit() {
      await this.deauth()
      this.showModal(false)
      this.quitOrderMenu()
    },
    quitOrderMenu() {
      if (this.isApp) {
        window.location.href = `${process.env.VUE_APP_BASE_CUSTOM_SCHEME}/close/smartphone_order_webview`
      } else {
        if (this.$route.path === '/') return
        this.$router.push({ path: '/' })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.modal-container {
  padding-top: 8px;
}
.content {
  color: #222222;
  &-subject {
    font-size: 18px;
    font-weight: bold;
    @media screen and (max-width: 375px) {
      font-size: 0.95rem;
    }
  }
  &-desc {
    padding: 20px 0;
    font-size: 14px;
  }
}
.col {
  padding-left: 4px;
  padding-right: 4px;
}
.buttons {
  padding: 10px 0;
  margin: 10px 0 0;
  width: 100%;
  height: 38px;
  line-height: 38px;
  border-radius: 5px;
  font-size: 1rem;
  font-weight: bold;
  padding: 0px 0 45px 0px;
  // for iphone5/SE
  @media screen and (max-width: 375px) {
    font-size: 0.85rem;
  }
  &-button {
    &-quit {
      border-radius: 5px;
      color: white;
      background-color: #d21b24;
      border-bottom: 2px solid #96131a;
    }
    &-cancel {
      border-radius: 5px;
      color: white;
      background-color: #666;
      border-bottom: 2px solid #333;
    }
  }
}
</style>
